import { MoreVertical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { ReceptionHistory } from '@/types/api'
import { formatDateTime } from '@/utils/format'
import type { CombinedColumnDef } from '@/api/dowload-excel.api'

interface BuildColumnsOptions {
  pageIndex: number
  pageSize: number
  onViewDetail?: (item: ReceptionHistory) => void
  onDelete?: (item: ReceptionHistory) => void
  showUnitColumn: boolean
  canView: boolean
}

export function buildColumns({
  pageIndex,
  pageSize,
  onViewDetail,
  showUnitColumn,
  canView,
}: BuildColumnsOptions): CombinedColumnDef<ReceptionHistory>[] {
  return [
    {
      id: 'stt',
      header: 'STT',
      size: 55,
      align: 'center',
      cell: ({ row }) => row.index + 1 + pageIndex * pageSize,
    },
    {
      accessorKey: 'title',
      header: 'TÊN HỘI THOẠI',
      align: 'left',
      cell: ({ row, getValue }) => (
        <button
          type="button"
          className="cursor-pointer text-[#CE7A58] hover:text-[#b8694a]"
          onClick={() => onViewDetail?.(row.original)}
        >
          {getValue() as string}
        </button>
      ),
    },
    {
      accessorKey: 'customerName',
      header: 'TÊN KHÁCH HÀNG',
      align: 'left',
      cell: ({ getValue }) => {
        const v = getValue() as string
        return <span className="text-gray-700">{v || '—'}</span>
      },
    },
    {
      accessorKey: 'robotName',
      header: 'TÊN ROBOT THỰC HIỆN',
      align: 'left',
      cell: ({ getValue }) => {
        const v = getValue() as string
        return <span className="text-gray-700">{v || '—'}</span>
      },
    },
    ...(showUnitColumn
      ? [
          {
            accessorKey: 'unitName',
            header: 'ĐƠN VỊ',
            align: 'left',
            cell: ({ getValue }) => {
              const v = getValue() as string
              return <span className="text-gray-700">{v || '—'}</span>
            },
          } satisfies CombinedColumnDef<ReceptionHistory>,
        ]
      : []),
    {
      id: 'date',
      accessorKey: 'startTime',
      header: 'NGÀY THỰC HIỆN',
      size: 155,
      align: 'center',
      cell: ({ getValue }) => formatDateTime(getValue()),
    },
    {
      id: 'actions',
      size: 55,
      align: 'center',
      exportable: false,
      cell: ({ row }) => (
        <div className="flex justify-center">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <MoreVertical />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-40">
              {canView && (
                <DropdownMenuItem
                  className="cursor-pointer"
                  onClick={() => onViewDetail?.(row.original)}
                >
                  Xem chi tiết
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      ),
    },
  ]
}
